import React, { useEffect, useState } from "react";
import PantheonNetworkScene from "../pantheonNetwork/PantheonNetworkScene";
import { PUBLIC_PANTHEON_NETWORK } from "../pantheonNetwork/publicPantheonNetworkConfig";
import "./PantheonNetworkEmbed.css";

const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";

function readReducedMotion() {
  try {
    return Boolean(
      typeof window !== "undefined" &&
        typeof window.matchMedia === "function" &&
        window.matchMedia(REDUCED_MOTION_QUERY).matches
    );
  } catch {
    return false;
  }
}

export default function PantheonNetworkEmbed() {
  const [reducedMotion, setReducedMotion] = useState(readReducedMotion);

  useEffect(() => {
    const previousRootRoute = document.documentElement.getAttribute("data-route");
    const previousBodyRoute = document.body.getAttribute("data-route");
    const previousTitle = document.title;
    document.documentElement.setAttribute("data-route", "/embed/pantheon-network");
    document.body.setAttribute("data-route", "/embed/pantheon-network");
    document.title = "Pantheon Intelligence Network";

    return () => {
      if (previousRootRoute) document.documentElement.setAttribute("data-route", previousRootRoute);
      else document.documentElement.removeAttribute("data-route");
      if (previousBodyRoute) document.body.setAttribute("data-route", previousBodyRoute);
      else document.body.removeAttribute("data-route");
      document.title = previousTitle;
    };
  }, []);

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return undefined;
    }
    const mediaQuery = window.matchMedia(REDUCED_MOTION_QUERY);
    const onChange = (event) => setReducedMotion(Boolean(event.matches));
    setReducedMotion(Boolean(mediaQuery.matches));
    if (typeof mediaQuery.addEventListener === "function") {
      mediaQuery.addEventListener("change", onChange);
      return () => mediaQuery.removeEventListener("change", onChange);
    }
    if (typeof mediaQuery.addListener === "function") {
      mediaQuery.addListener(onChange);
      return () => mediaQuery.removeListener(onChange);
    }
    return undefined;
  }, []);

  return (
    <main
      className={`pnc-embed ${reducedMotion ? "is-reduced-motion" : ""}`}
      data-testid="pantheon-network-embed"
      data-reduced-motion={reducedMotion ? "true" : "false"}
      aria-hidden="true"
    >
      <div className="pnc-embed-stage" data-testid="pnc-embed-stage">
        <PantheonNetworkScene
          viewModel={PUBLIC_PANTHEON_NETWORK}
          presentation="embed"
          reducedMotion={reducedMotion}
          showLabels={false}
          showCrossLinks
        />
      </div>
    </main>
  );
}
